import { useContext } from "react";

import { AuthContext } from "../common/auth/AuthContext";

/**
 * Access the current authentication state and actions.
 *
 * @returns {{
 *   status: "initializing"|"signed-out"|"signed-in"|"unavailable",
 *   authUser: object|null,
 *   profile: object|null,
 *   error: {message: string, detail: any}|null,
 *   authReady: boolean,
 *   authLoading: boolean,
 *   isGuest: boolean,
 *   isLocalMode: boolean,
 *   backendMode: {mode: string, missing: string[], message: string},
 *   pendingAction: string|null,
 *   ensureAuthReady: () => Promise<any>,
 *   continueAsGuest: () => Promise<any>,
 *   signInWithGoogle: () => Promise<any>,
 *   upgradeAccount: () => Promise<any>,
 *   signOut: () => Promise<any>,
 *   clearError: () => void,
 * }}
 */
export default function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used inside <AuthProvider>");
  }
  return context;
}
